import React from 'react';
import { Tag, Tooltip } from 'antd';

function RenderTooltipCurrency({currency, amount, rate}) {
  return (
    <Tooltip title={rate === 0 ? '' : `£${(parseFloat(amount) * parseFloat(rate)).toFixed(2)}`}>
      <Tag color="#FB607F"><b>{currency} {amount.toLocaleString()}</b></Tag>
    </Tooltip>
  );
}

export default RenderTooltipCurrency;


